<script setup>
import { ref, onMounted, watch } from 'vue'
import Cookies from 'js-cookie'

const darkMode = ref(false)
const cookieName = 'darkmode'
const bodyElement = document.documentElement

// Load dark mode preference from cookies or device preference on mount
onMounted(() => {
    const saved = Cookies.get(cookieName)
    if (saved !== undefined) {
        darkMode.value = saved === 'true'
    } else {
        // Check device preference
        darkMode.value = window.matchMedia(
            '(prefers-color-scheme: dark)'
        ).matches
    }
})

// Watch for changes and save preference to cookies
watch(darkMode, (val) => {
    Cookies.set(cookieName, val, { expires: 365 })
    if (val) {
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
    }
})
</script>

<template>
    <div class="c-darkmode-toggle">
        <button
            @click="darkMode = !darkMode"
            class="c-darkmode-toggle__button c-button"
        >
            {{ darkMode ? 'Dark Mode' : 'Light Mode' }}
        </button>
    </div>
</template>
